module.exports = __webpack_public_path__ + "static/media/defaultPrimary.9620ca97.png";